import { $ } from 'rune-ts';
import { CreatorProductData } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { FormValidator } from './FormValidator.ts';
import { ErrorHandler } from './ErrorHandler.ts';
import { ActionManager } from './ActionManager.ts';
import { SeeMoreSettingItem } from '@shared/rune-component/Button/SeeMoreSettingButton/SeeMoreSettingButton.ts';
import { BaseForm } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/BaseForm.ts';
import { Confirm } from '@services/MarppleShop/renderApp/components/cells/Confirm/Confirm.ts';
import { navigateTo } from '@services/MarppleShop/shared/app/util.ts';
import { makeEmptyScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';

/**
 * 폼의 모든 기능을 통합 관리하는 컨트롤러
 */
export class FormController<T extends CreatorProductData = CreatorProductData> {
  private readonly validator: FormValidator;
  private readonly errorHandler: ErrorHandler;
  private readonly actionManager: ActionManager;

  constructor(private form: BaseForm<T>) {
    /*  */
    this.validator = new FormValidator(this.form);

    /*  */
    this.errorHandler = new ErrorHandler(this.form);

    /* 에디터의 다양한 액션을 관리합니다. 등록하기, 수정하기, 삭제하기 등 */
    this.actionManager = new ActionManager(this.form, this.validator, this.errorHandler);
  }

  /**
   * 폼 저장
   */
  async save(): Promise<void> {
    await this.actionManager.executeSave();
  }

  /**
   * 임시 저장
   */
  async tempSave(): Promise<void> {
    await this.actionManager.executeTempSave();
  }

  /**
   * 더보기 액션 아이템 생성
   */
  createSeeMoreItems(): SeeMoreSettingItem[] {
    return this.actionManager.createSeeMoreItems();
  }

  /**
   * 성인 인증 필요 체크
   */
  async checkNeedAdult() {
    const need_adult_checked = $('html[need_adult_check="true"]');
    const need_certification = $(need_adult_checked)?.find('[need_certification="true"]');
    if (need_adult_checked && need_certification && this.form.store.formData.meta.adult) {
      const confirmed = await Confirm.open({
        title: ET('mps2::adult::need_verify'),
        message: T('mshop::성인 인증이 필요합니다.인증을 진행하시겠습니까?'),
        confirmText: ET('mps2::adult::go_verify'),
        whiteSpace: 'pre_line',
      });

      if (confirmed) {
        navigateTo(`${this.form.data.store_url}/settings/ecommerce_info`, makeEmptyScreenNavigate);
      }
    }
  }
}
